import { PrivateRouteProvider, useAuthenticatedUser } from 'contexts'

import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { PATHS } from 'utils/constants'
import { useLoading } from 'utils/hooks'

const PrivateRoute = () => {
  const { authenticatedUser, isLoading } = useAuthenticatedUser()
  const { Loading } = useLoading()

  if (isLoading) {
    return <Loading />
  }

  if (authenticatedUser.clientPrincipal === null) {
    return <Navigate to={PATHS.signIn} />
  }

  return (
    <PrivateRouteProvider>
      <Outlet />
    </PrivateRouteProvider>
  )
}

export default PrivateRoute
